import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, MapPin, Globe } from 'lucide-react';
import { useLanguage } from '../i18n/LanguageContext';
export function CTASection() {
  const {
    lang
  } = useLanguage();
  return <section id="contacto" className="relative py-[120px] text-center overflow-hidden bg-gradient-to-br from-inkova-dark-purple via-inkova-primary to-[#8B5CF6]" data-id="element-69">
      {/* Decorative background element */}
      <div className="absolute top-[-50%] left-[-50%] w-[200%] h-[200%] bg-[radial-gradient(circle_at_60%_40%,rgba(192,132,252,0.15)_0%,transparent_60%)] pointer-events-none" data-id="element-70" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-71">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-72">
          <h2 className="text-[32px] sm:text-[4vw] lg:text-[52px] font-serif text-white leading-[1.2] mb-5" data-id="element-73">
            {lang === 'es' ? 'Visualízalo. Pero esta vez, acciona.' : 'Visualize it. But this time, take action.'}
          </h2>

          <p className="text-[17px] text-white/80 max-w-[580px] mx-auto leading-[1.75] mb-12" data-id="element-74">
            {lang === 'es' ? 'Tu negocio digital con propósito no va a construirse solo. El primer paso es el más importante — y el más sencillo.' : 'Your digital business with purpose is not going to build itself. The first step is the most important — and the simplest.'}
          </p>

          <div className="flex flex-wrap justify-center gap-4 mb-14" data-id="element-75">
            <a href="https://inkovacreation.store/shop/341dc5f2-2e37-4bec-89a7-31063f77eefd" target="_blank" rel="noopener noreferrer" className="inline-flex flex-col items-center bg-gradient-to-br from-white to-[#F3EEFA] text-inkova-primary px-9 py-4 rounded-full font-bold text-[15px] shadow-[0_8px_32px_rgba(255,255,255,0.25)] hover:scale-[1.02] hover:-translate-y-0.5 hover:shadow-[0_16px_48px_rgba(255,255,255,0.4)] transition-all duration-300" data-id="element-76">
              {lang === 'es' ? 'DA EL PRIMER PASO' : 'TAKE THE FIRST STEP'}
              <small className="text-[11px] font-normal opacity-70 mt-1" data-id="element-77">
                {lang === 'es' ? 'Sesión Diagnóstico · $50 · 30 minutos' : 'Diagnostic Session · $50 · 30 minutes'}
              </small>
            </a>

            <a href="https://wa.me/13054781618" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center border-[1.5px] border-white/60 text-white px-8 py-4 rounded-full font-medium text-[15px] hover:bg-white/10 hover:border-white hover:scale-[1.02] transition-all duration-300" data-id="element-78">
              {lang === 'es' ? 'Tengo una pregunta → WhatsApp' : 'I have a question → WhatsApp'}
            </a>
          </div>

          <hr className="border-t border-white/20 max-w-[400px] mx-auto mb-10" data-id="element-79" />

          <div className="flex flex-wrap justify-center gap-6 sm:gap-12" data-id="element-80">
            <div className="flex items-center gap-2 text-sm text-white/85" data-id="element-81">
              <Sparkles className="w-4 h-4 text-inkova-accent shrink-0" strokeWidth={1.5} data-id="element-82" />
              {lang === 'es' ? '100+ negocios construidos' : '100+ businesses built'}
            </div>
            <div className="flex items-center gap-2 text-sm text-white/85" data-id="element-83">
              <MapPin className="w-4 h-4 text-inkova-accent shrink-0" strokeWidth={1.5} data-id="element-84" />
              Miami, Florida
            </div>
            <div className="flex items-center gap-2 text-sm text-white/85" data-id="element-85">
              <Globe className="w-4 h-4 text-inkova-accent shrink-0" strokeWidth={1.5} data-id="element-86" />
              {lang === 'es' ? 'Para emprendedores en cualquier parte del mundo' : 'For entrepreneurs anywhere in the world'}
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}